module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner.5970acb1.jpg";